var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEqx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1001,
    cy: 10.5,
    r: 10.5,
    fill: "url(#paint0_linear_1394_14392)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2666 4.62891V16.3341H13.8204L13.7969 14.7513H6.84934V6.21172H16.9714V4.62891H5.2666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43242 9.4141H15.4062V11.2508H8.43018V12.8719H15.4062V16.3342H16.9733V7.79297H8.43242V9.4141Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1394_14392",
    x1: -3.74915,
    y1: 10.5,
    x2: 11.1001,
    y2: 25.3492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#0B6370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45BDA4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqx);
export default __webpack_public_path__ + "static/media/eqx.a9da3ceaa42c42cd292d76712778effb.svg";
export { ForwardRef as ReactComponent };